module.exports = __webpack_public_path__ + "media/base/subcontractor_medium-48204446.svg";